export enum LuckySpinRewardsQueryKeys {
  ByLuckySpin = 'lucky-spin-rewards/by-lucky-spin',
}
